import React from 'react';

export default function PageContainer({ children, className = '' }) {
  return (
    <div className={`max-w-[1200px] w-full mx-auto px-6 sm:px-8 py-6 space-y-6 ${className}`}>
      {children}
    </div>
  );
}
